import { UpdateKycProps } from '.';
import OrgsService from '../../services/orgs';
import { updateStripePerson } from '../../services/vault/stripePerson';
import { createShortLivedToken } from '../../services/vault/token';
import logger, { logVgsFormSubmitResponse } from '../../util/logger';
import { SubmitProps } from '../KycForm';
import { requestBodyFormatter } from './requestBodyFormatter';

const submit =
  ({ stripeEnv, kycId, onSuccess }: UpdateKycProps) =>
  async ({
    form,
    kycAddressRegion,
    kycPercentOwnership,
    kycTitle,
    kycOwner,
    provider,
  }: SubmitProps): Promise<void> => {
    const token = await createShortLivedToken();

    return new Promise((resolve, reject) => {
      form.submit(
        '/graphql',
        {
          data: requestBodyFormatter({
            kycId,
            kycAddressRegion,
            kycOwner,
            kycPercentOwnership,
            kycTitle,
          }),
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
        async (responseStatus, { data, errors }) => {
          logVgsFormSubmitResponse({
            formName: 'UpdateKyc',
            responseStatus,
            data,
            errors,
          });
          if (responseStatus !== 200) {
            throw new Error(`Received ${responseStatus} status.`);
          }

          const financialAcctUsers =
            await OrgsService.getFinancialAcctUsersByKycId(kycId);
          const filteredFinancialAcctUsers = financialAcctUsers.filter(
            (fau) =>
              fau.processor === provider.toUpperCase() &&
              !!fau.acctId &&
              !!fau.personId,
          );
          try {
            await Promise.all(
              filteredFinancialAcctUsers
                .filter((fau) => fau.acctId !== undefined)
                .map((fau) =>
                  updateStripePerson(
                    fau.kycId,
                    // confirmed that acctId is not undefined in filter above
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    fau.acctId!,
                    fau.personId,
                    stripeEnv,
                  ),
                ),
            );
            if (onSuccess !== undefined) {
              const successData = filteredFinancialAcctUsers
                .filter((fau) => fau.userId !== undefined)
                .map((fau) => ({
                  kycId,
                  personId: fau.personId,
                  acctId: fau.acctId,
                  provider,
                  // confirmed that userId is not undefined in filter above
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  userId: fau.userId!,
                }));
              logger(`UpdateKyc successData ${JSON.stringify(successData)}`);
              onSuccess(successData);
            }
            resolve();
          } catch (e) {
            reject(e);
          }
        },
        (errors) => {
          reject(errors);
        },
      );
    });
  };

export default submit;
